import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button as Button } from '@factorialco/f0-react'
import { Plus } from '@factorialco/f0-react/icons/app'

import { ApprovalSettingsModal } from './ApprovalSettingsModal'
import { StrategiesDisplay } from './StrategiesDisplay'
import { StrategyItem, StrategyType } from './utils/interfaces'

interface ApproverSelectionContainerProps {
  strategies: StrategyItem[]
  unselectableStrategies?: StrategyType[]
  onAddStrategies: (strategies: StrategyItem[]) => void
  onDeleteStrategy: (strategyId: string) => void
  unselectableEmployees?: Array<number>
  unselectableTeams?: Array<number>
  unselectableRoles?: Array<number | string>
  entityLabel: string
  newEntityLabel: string
  maxStrategies?: number
}

export const ApproverSelectionContainer = ({
  strategies,
  unselectableStrategies = [],
  onAddStrategies,
  onDeleteStrategy,
  unselectableEmployees = [],
  unselectableTeams = [],
  unselectableRoles = [],
  entityLabel,
  newEntityLabel,
  maxStrategies = Number.POSITIVE_INFINITY,
}: ApproverSelectionContainerProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Box gap="s8" width="full">
      <Box gap="s2" width="full">
        <StrategiesDisplay strategies={strategies} onDeleteStrategy={onDeleteStrategy} />
      </Box>

      {strategies.length < maxStrategies && (
        <Box flexDirection="row" justifyContent="flexStart" width="full" paddingTop="s8">
          <Button
            icon={Plus}
            label={newEntityLabel}
            onClick={() => setIsModalOpen(true)}
            size="md"
            variant="outline"
          />
        </Box>
      )}

      <ApprovalSettingsModal
        entityLabel={entityLabel}
        newEntityLabel={newEntityLabel}
        isOpen={isModalOpen}
        onAddStrategies={onAddStrategies}
        onClose={() => setIsModalOpen(false)}
        strategies={strategies}
        unselectableEmployees={unselectableEmployees}
        unselectableRoles={unselectableRoles}
        unselectableStrategies={unselectableStrategies}
        unselectableTeams={unselectableTeams}
      />
    </Box>
  )
}
